export default "__VITE_ASSET__EsYMncvV__"